import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { get } from "lodash";
import CookieSettingsLink from "./CookieSettingsLink";
import { sunny } from "../../constants/colors";
import Link from "../../components/Link";

const StlFooterWrapper = styled.div`
  width: 100%;
  .cookie-wrapper {
    height: 30px;
    display: flex;
  }
`;

const StlFooter = styled.footer`
  background-color: ${sunny};
  padding: 40px;
  width: 100%;
  box-shadow: 0px 2px 4px 0px #0000001a;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (min-width: 640px) {
    flex-direction: row;
    justify-content: space-between;
    padding: 20px;
  }

  @media (min-width: 768px) {
    padding-left: 40px;
    padding-right: 40px;
  }
`;

const StlLink = styled.a`
  margin-bottom: 20px;

  @media (min-width: 640px) {
    margin-bottom: 0;
  }
`;

const StlImg = styled.img`
  height: 50px;
  margin-bottom: 15px;

  @media (min-width: 640px) {
    width: 190px;
    margin-bottom: 0;
  }
`;

const Footer = (props) => {
  const data = useSelector((state) => get(state, "prismic.footer.data", false));

  return (
    <StlFooterWrapper>
      {data && (
        <StlFooter data-state="Pennsylvania">
          <StlLink href="/">
            <StlImg className="contain-img" src={get(data, "logo.url")} />
          </StlLink>

          <Link
            color="secondary"
            url={get(data, "shop_link.url")}
            className="footer-button"
            target="_blank"
          >
            {get(data, "link_text")}
          </Link>
        </StlFooter>
      )}
      <div className="cookie-wrapper">
        <CookieSettingsLink />
      </div>
    </StlFooterWrapper>
  );
};

export default Footer;
